import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {CloseIcon, EffectIcon, FlipIcon} from "../../../assets/icons";
import {
    BlendAndOpacity,
    BlendMode,
    ControlItem,
    ControlsWrapper,
    ControlTitle,
    OpacityMode, SpecialEffectsWrapper, StyledSlider
} from "../../../Components/StyledComponents";
import ModalDialog from "../../../Components/ModalDialog";
import ReplaceModelContent from "../../../Components/ModalContents/ReplaceModalContent";
import Switch from '@mui/material/Switch';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import styled from 'styled-components';
import CropIcon from '@mui/icons-material/Crop';
import {fabric} from 'fabric';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import WallpaperIcon from '@mui/icons-material/Wallpaper';
import HideImageIcon from '@mui/icons-material/HideImage';
import Box from "@mui/material/Box";
import {addArtImage} from "../../../utils/addItems";
import {setBackgroundState, setLoading} from "../../../store/reducers/modalToggler";
import {List, ListItem, ListItemText} from '@mui/material';
import ListItemButton from '@mui/material/ListItemButton';
import {
    applyFeathering, changeSVGColor,
    createMultipleObjects,
    createThumbnail, fileUploaderToServer, getRelativePath, horizontalFlip,
    initializeScale,
    roundedCorners,
    setCanvasBackground, testFileTypes, verticalFlip
} from "../../../utils/helpers";
import {updateSheetBackgroundImage, updateSheetThumbnail} from "../../../store/reducers/availableSheets";
import Grid from "@mui/material/Grid";
import MuiInput from "@mui/material/Input";
import ImageViewer from "../../../Components/ImageViewer";
import {updateUndoRedoState} from "../../../utils/undo-redo";
import {bgRemover, imageEnhancement} from "../../../utils/apiHelper";
import CropModal from "../../../Components/ModalContents/CropModal";
import {createPortal} from "react-dom";
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import {marks} from "../../../utils/constants";
import Menu from "@mui/material/Menu";
import ListItemIcon from "@mui/material/ListItemIcon";
import PermMediaIcon from "@mui/icons-material/PermMedia";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {setUrlsInNewImageList, setUserImagesList} from "../../../store/reducers/userImagesListSlice";
import {showToast} from "../../../store/reducers/notificationSlice";
import { toast } from 'react-toastify';
import BlurOnIcon from '@mui/icons-material/BlurOn';
import ExpandableColorHolder from "./ExpandableColorHolder";

const Input = styled(MuiInput)`
  width: 42px;
`;

const StyledListItem = styled(ListItem)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledSwitch = styled(Switch)`
  margin-left: 10px;
`;
let circle = 'M 100 100 A 50 50 0 1 0 100 99.99';
let ellipse = ' M 200 150 A 80 50 0 1 0 200 250 A 80 50 0 1 0 200 149.99';
let rect = 'M 0 0 L 500 0 L 500 500 L 0 500 Z';
let heart = 'M140 20C73 20 20 74 20 140c0 135 136 170 228 303 88-132 229-173 229-303 0-66-54-120-120-120-48 0-90 28-109 69-19-41-60-69-108-69z';

let shadow = {
    color: '#888888',
    blur: 70,
    offsetX: 45,
    offsetY: 45,
    opacity: 0.8
}

let shapeArray = [{path: null, name: 'None'}, {path: heart, name: 'Heart'}, {path: rect, name: 'Curved'}, {path: circle, name: 'Circle'}, {path: ellipse, name: 'Ellipse'}, {name: 'Shadow', path: shadow}]

const tempArray = [];

const ImageProperties = ({setToggleSubMenu, stopEvents, initEvents, setValue}) => {
    const {canvas} = useSelector((state) => state.canvas);
    const {activeSetting} = useSelector((state) => state.canvas);
    const {activeObject} = useSelector((state) => state.canvas);
    const activeSheet = useSelector((state) => state.activeSheet).sheet;
    const imageCollection = useSelector((state) => state.userImagesList).userImagesList;
    const {isLoggedIn} = useSelector((state) => state.loginSlice);
    const {toggleSetBG} = useSelector((state) => state.modalToggle);

    const [openReplaceModal, setOpenReplaceModal] = useState(false);
    const [blendFilter, setBlendFilter] = React.useState('source-over');
    const [opacity, setOpacity] = React.useState(1);
    const [bgOpacity, setBgOpacity] = React.useState(1);
    const [imgFilter, setImgFilter] = React.useState(false);
    const [edgeEffects, setEdgeEffects] = React.useState(false);
    const [imgAdjustments, setImgAdjustments] = React.useState(false);
    const [imgBlur, setImgBlur] = React.useState(false);
    const [brightness, setBrightness] = useState(0);
    const [contrast, setContrast] = useState(0);
    const [vibrance, setVibrance] = useState(0);
    const [saturation, setSaturation] = useState(0);
    const [noise, setNoise] = useState(0);
    const [blur, setBlur] = useState(0);
    const [uploaderCount, setUploaderCount] = useState(0);
    const [roundedCorner, setRoundedCorner] = useState(20);
    const [selectedPath, setSelectedPath] = useState('');
    const [openCropModal, setOpenCropModal] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [imageSrc,setImageSrc] = useState(null)


    const open = Boolean(anchorEl);
    const inputRef = useRef();
    const dispatch = useDispatch()

    useEffect(() => {
        if (activeObject && activeObject.filters) {
            const updatedFilters = [...filters];
            for (let i = 0; i < updatedFilters.length; i++) {
                const filter = updatedFilters[i];
                const filterEnabled = activeObject.filters[filter.index] instanceof fabric.Image.filters[filter.name];
                filter.enabled = filterEnabled;
            }
            setFilters(updatedFilters);

            if (activeObject && Array.isArray(activeObject.filters)) {
                const filters = activeObject.filters;
                const filterIndices = [5, 6, 7, 8, 9, 11];

                const filterValues = filterIndices.map((index) => {
                    const filter = filters[index];
                    if (filter instanceof fabric.Image.filters.Brightness) {
                        return filter.brightness || 0;
                    } else if (filter instanceof fabric.Image.filters.Contrast) {
                        return filter.contrast || 0;
                    } else if (filter instanceof fabric.Image.filters.Vibrance) {
                        return filter.vibrance || 0;
                    } else if (filter instanceof fabric.Image.filters.Saturation) {
                        return filter.saturation || 0;
                    } else if (filter instanceof fabric.Image.filters.Noise) {
                        return filter.noise || 0;
                    } else if (filter instanceof fabric.Image.filters.Blur) {
                        return filter.blur || 0;
                    }
                    return 0;
                });

                setBrightness(filterValues[0] * 100);
                setContrast(filterValues[1] * 100);
                setVibrance(filterValues[2] * 100);
                setSaturation(filterValues[3] * 100);
                setNoise(filterValues[4]);
                setBlur(parseInt(filterValues[5] * 100));
            }
        }
        if (activeObject) {
            if (activeObject.clipPath) {
                setSelectedPath(activeObject.clipPath.name)
                setRoundedCorner(activeObject.scaleX * activeObject.clipPath.rx)
            } else setSelectedPath(null)
        }
    }, [activeObject, activeSetting])

    const [filters, setFilters] = useState([
        {index: 0, name: 'Grayscale', enabled: false},
        {index: 3, name: 'Sepia', enabled: false},
        {index: 19, name: 'BlackWhite', enabled: false},
        {index: 4, name: 'Brownie', enabled: false},
        {index: 9, name: 'Vintage', enabled: false},
    ]);
    const blendModes = [
        {label: 'Normal', mode: 'source-over'},
        {label: 'Subtract', mode: 'difference'},
        {label: 'Multiply', mode: 'multiply'},
        {label: 'Lighten', mode: 'lighten'},
        {label: 'Darken', mode: 'darken'},
        {label: 'Screen', mode: 'screen'},
        {label: 'Overlay', mode: 'overlay'},
    ];

    const handleChangeBlend = (event) => {
        if (!activeObject) return
        setBlendFilter(event.target.value);
        activeObject.globalCompositeOperation = event.target.value;
        canvas.renderAll();
        canvas.fire('object:modified', {target: activeObject});
    };

    const applyFilterValue = (index, prop, value) => {
        let obj = activeObject
        if (obj.filters[index]) {
            obj.filters[index][prop] = value;
            obj.applyFilters();
            canvas.renderAll();
        }
    }

    useEffect(() => {
        if (activeSetting) {
            const {opacity} = activeSetting;
            setOpacity(opacity * 100)
        }
    }, [activeSetting]);

    useEffect(() => {
        if(canvas?.backgroundImage){
            setBgOpacity(canvas.backgroundImage.opacity * 100)
        }
    }, [activeSheet]);

    const closeImagesPanel = () => {
        setToggleSubMenu(false)
    }

    const CloseReplaceModal = () => {
        setOpenReplaceModal(false);
    }
    const ToggleReplaceModal = () => {
        setOpenReplaceModal(true);
    }

    const getImageSrc = (url) => {
        let queryIndex = url.indexOf('?');
        if (queryIndex === -1) {
            return url;
        }
        return url.substring(0, queryIndex);
    }

    const RestoreImage = async () => {
        try {
            if (!activeObject || activeObject.type !== 'image') {
                return;
            }

            dispatch(setLoading(true));

            const imgSrc = getImageSrc(activeObject.getSrc());
            const src = getRelativePath(imgSrc);

            const imageUrl = await imageEnhancement(src);
            const currentImage = canvas.getActiveObject();

            if (currentImage) {
                await addArtImage(`${process.env.REACT_APP_cdnURL}/` + imageUrl, currentImage.left, currentImage.top, canvas, currentImage.id, activeSheet);
                canvas.remove(currentImage);
                canvas.renderAll();
                dispatch(showToast({ message: 'Image restored', type: 'success' }));
            }
        } catch (error) {
            console.error('Error restoring image:', error);
            dispatch(showToast({ message: 'Please try uploaded images', type: 'error' }));
        } finally {
            dispatch(setLoading(false));
            canvas.fire('object:modified', { target: activeObject });
        }
    };


    function valuetext(value) {
        return value;
    }

    function valueRounded(value) {
        return value;
    }

    const handleOpacityChange = (event, value) => {
        const opacity = value / 100;
        if (activeObject) {
            activeObject.set({opacity: opacity});
            setOpacity(value)
            canvas.renderAll();
        }
    };

    const handleBackgroundOpacity = (event, value) => {
        const opacity = value / 100;
        if (canvas.backgroundImage) {
            canvas.backgroundImage.set({opacity: opacity});
            setBgOpacity(value)
            canvas.renderAll();
        }
    };
    const removeBackground = async () => {
        if (!activeObject || activeObject.type !== 'image') return
        if (!isLoggedIn) {
            alert('Please log in first')
            return
        }
        toast.promise(
            bgRemover(activeObject.getSrc())
            .then((imageUrl)=>{
                const currentImage = canvas.getActiveObject();
                const index = canvas.getObjects().indexOf(currentImage);
                addArtImage(imageUrl, currentImage.left, currentImage.top, canvas, currentImage.id, activeSheet).then((newImage) => {
                    canvas.remove(currentImage);
                    canvas.moveTo(newImage, index);
                    canvas.renderAll();
                })
                canvas.fire('object:modified', {target: activeObject});
            }),
            {
                pending: {
                    render(){
                        return "Please wait, removing background"
                    },
                },
                success: {
                    render({data}){
                        return 'Background removed'
                    },
                    icon: "🟢",
                },
                error: {
                    render({data}){
                        return `Error! please try on any other image`
                    }
                }
            }
        )
    };

    const toggleAccordion = (event, accordion) => {
        if (event.target.type === 'checkbox') return
        switch (accordion) {
            case 'filters' :
                setImgFilter(!imgFilter)
                break;
            case 'adjustments':
                setImgAdjustments(!imgAdjustments)
                break;
            case 'blur':
                setImgBlur(!imgBlur)
                break;
            case 'edgeEffects':
                setEdgeEffects(!edgeEffects)
                break;
            default:
                break
        }
    };

    function toggleFilter(index) {
        if (!activeObject || activeObject.type !== 'image') return
        setFilters(prevFilters => {
            const updatedFilters = [...prevFilters];
            const filter = updatedFilters[index];
            const filterEnabled = activeObject && activeObject.filters && activeObject.filters[filter.index] instanceof fabric.Image.filters[filter.name];

            if (filterEnabled) {
                activeObject.filters[filter.index] = null;
                filter.enabled = false;
            } else {
                const newFilter = new fabric.Image.filters[filter.name]();
                activeObject.filters[filter.index] = newFilter;
                filter.enabled = true;
            }

            activeObject.applyFilters();

            canvas.renderAll();
            return updatedFilters;
        });
        canvas.fire('object:modified', {target: activeObject});
    }

    const handleBrightnessChange = (event, value) => {
        if (!activeObject || activeObject.type !== 'image') return
        if (!activeObject.filters[5]) {
            activeObject.filters[5] = new fabric.Image.filters.Brightness();
            activeObject.applyFilters();
        }
        let newVal = value / 100;
        setBrightness(value);
        applyFilterValue(5, 'brightness', newVal)
    };

    const handleContrastChange = (event, value) => {
        if (!activeObject || activeObject.type !== 'image') return
        if (!activeObject.filters[6]) {
            activeObject.filters[6] = new fabric.Image.filters.Contrast();
            activeObject.applyFilters();
        }
        let newVal = value / 100;
        applyFilterValue(6, 'contrast', newVal)
        setContrast(value);
    };

    const handleVibranceChange = (event, value) => {
        if (!activeObject || activeObject.type !== 'image') return
        if (!activeObject.filters[8]) {
            activeObject.filters[8] = new fabric.Image.filters.Vibrance();
            activeObject.applyFilters();
        }
        let newVal = value / 100;
        applyFilterValue(8, 'vibrance', newVal)
        setVibrance(value);
    };

    const handleSaturationChange = (event, value) => {
        if (!activeObject || activeObject.type !== 'image') return
        if (!activeObject.filters[7]) {
            activeObject.filters[7] = new fabric.Image.filters.Saturation();
            activeObject.applyFilters();
        }
        let newVal = value / 100;
        applyFilterValue(7, 'saturation', newVal)
        setSaturation(value);
    };
    const handleNoiseChange = (event, value) => {
        if (!activeObject || activeObject.type !== 'image') return
        if (!activeObject.filters[9]) {
            activeObject.filters[9] = new fabric.Image.filters.Noise();
            activeObject.applyFilters();
        }
        applyFilterValue(9, 'noise', value)
        setNoise(value);
    };
    const handleBlurChange = (event, value) => {
        if (!activeObject || activeObject.type !== 'image') return
        if (!activeObject.filters[11]) {
            activeObject.filters[11] = new fabric.Image.filters.Blur();
            activeObject.applyFilters();
        }
        applyFilterValue(11, 'blur', value / 100)
        setBlur(value);
    };

    const applyClipPath = (item) => {
        if (!activeObject || activeObject.type !== 'image') return;
        setSelectedPath(item.name)
        if (item.name === 'None') {
            activeObject.set('shadow', null)
        }
        if (!item.path) {
            activeObject.clipPath = item.path;
            let elementToDraw = activeObject._element,
                elWidth = elementToDraw.naturalWidth || elementToDraw.width,
                elHeight = elementToDraw.naturalHeight || elementToDraw.height;
            activeObject.set({width: elWidth, height: elHeight});
            canvas.renderAll();
            return;
        } else {
            if (item.name === 'Curved') {
                activeObject.set('clipPath', roundedCorners(activeObject, 20, 20))
            } else if (item.name === 'Shadow'){
                activeObject.set('shadow', item.path)
            } else {
                const path = new fabric.Path(item.path, {
                    name: item.name,
                    fill: '',
                    stroke: '',
                    objectCaching: false,
                    left: activeObject.left,
                    top: activeObject.top,
                    absolutePositioned: true,
                });

                activeObject.set({
                    clipPath: path,
                });
                initializeScale(activeObject, activeObject.clipPath)
            }
        }
        canvas.renderAll();
        canvas.fire('object:modified', {target: activeObject});
    };

    const removeRectangleFilter = () => {
        if (activeObject && activeObject.filters) {
            var index = activeObject?.filters.findIndex(function (filter) {
                return filter?.type === 'feathering4';
            });

            if (index !== -1) {
                activeObject.filters.splice(index, 1);
                activeObject.applyFilters();
                canvas.renderAll();
            }
        }
    }

    const handleRoundedChange = (e) => {
        let val = e.target.value
        activeObject.set('clipPath', roundedCorners(activeObject, val, val))
        setRoundedCorner(val)
        canvas.renderAll()
    }

    const removeCanvasBackground = () => {
        canvas.setBackgroundImage(null, canvas.renderAll.bind(canvas))
        if(activeSheet.backgroundImage){
            dispatch(updateSheetBackgroundImage({
                sheetId: activeSheet.id,
                backgroundImage: canvas.backgroundImage,
            }))
        }
        createThumbnail(canvas).then((thumbnail) => dispatch(updateSheetThumbnail({
            sheetId: window.activeSheetId,
            thumbnail,
        })));
        updateUndoRedoState('background', 'background changed', canvas, window.activeSheet, dispatch);
    };

    const toggleCrop = () => {
        const activeObj = canvas.getActiveObject();
        if (activeObj instanceof fabric.Image) {
            setOpenCropModal(pre => !pre)
        }
    }

    const cropEnd = async (base64Image, crop, imageToCrop) => {
        dispatch(setLoading(true))
        const blob = await fetch(base64Image)
            .then(res => res.blob());
        const file = new File([blob], `cropped_${Date.now()}.png`, { type: 'image/png' });
        const activeObj = canvas.getActiveObject();
        const resImageFiles = await fileUploaderToServer([file], 1, dispatch);
        let imageUrl = resImageFiles[0].image
        addArtImage(imageUrl, activeObj.left, activeObj.top, canvas, activeObj.id, activeSheet,  true).then((newImage) => {
            newImage.originalSrc = imageToCrop;
            newImage.crop = crop;
            newImage.dirty = true;
            canvas.remove(activeObj);
            canvas.renderAll();
            dispatch(setLoading(false))
        })
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleRectangleEffect = () => {
        if(activeObject && activeObject.type === 'image'){
            if(activeObject.feathering){
                activeObject.set('feathering', false)
                removeRectangleFilter()
            }else{
                applyFeathering(activeObject, canvas)
            }
        }
    };

    const controlItems = [
        {
            onClick: RestoreImage,
            Icon: <AutoFixHighIcon/>,
            title: "Restore"
        },
        {
            onClick: () => verticalFlip(activeObject, canvas),
            Icon: <FlipIcon/>,
            title: "Flip Vertical"
        },
        {
            onClick: () => horizontalFlip(activeObject, canvas),
            Icon: <FlipIcon/>,
            title: "Flip Horizontal"
        },
        {
            onClick: removeBackground,
            Icon: <FlipIcon/>,
            title: "Remove Background"
        },
        {
            onClick: toggleCrop,
            Icon: <CropIcon color={'action'}/>,
            title: "Crop"
        },
        {
            onClick: handleRectangleEffect,
            Icon: <BlurOnIcon color={'action'}/>,
            title: "Blur Edges"
        },
        {
            onClick: handleClick,
            Icon: <WallpaperIcon color={'action'}/>,
            title: "Image BG"
        },
        {
            onClick: removeCanvasBackground,
            Icon: <HideImageIcon color={'action'}/>,
            title: "Delete BG"
        }
    ];

    const handleClose = () => {
        setAnchorEl(null);
    };


    const newInputHandler = async (event) => {
        dispatch(setLoading(true));
        const files = Array.prototype.slice.call(event.target.files);
        setUploaderCount(uploaderCount + 1);
        if (testFileTypes(files)) {
            const newImageList = createMultipleObjects(files.length, uploaderCount);
            dispatch(setUserImagesList([...newImageList, ...imageCollection]));
            tempArray.push(...newImageList, ...imageCollection);
            return new Promise(async (resolve) => {
                const resImageFiles = await fileUploaderToServer(files, uploaderCount, dispatch);
                if(resImageFiles){
                    if(toggleSetBG){
                        setCanvasBackground(canvas, resImageFiles[0].image, dispatch, activeSheet)
                        canvas.renderAll()
                        dispatch(setBackgroundState(false))
                    }else{
                        replaceImage(resImageFiles[0], resImageFiles[0].id)
                    }
                    dispatch(setUrlsInNewImageList({resImageFiles, activeSheet}));
                    resolve(true);
                }
            });
        } else {
            dispatch(showToast({ message: "Upload type is not allowed!", type: "error" }));
            dispatch(setLoading(false));
        }
    };

    const uploadFile = () => {
        if (!isLoggedIn) {
            alert('Please login first')
            return;
        }
        dispatch(setBackgroundState(true))
        inputRef.current.click();
        handleClose()
    };

    const replaceImage = (imageUrl, id) => {
        const currentImage = canvas.getActiveObject();
        let url = imageUrl.CompressedUrl ? `${process.env.REACT_APP_cdnURL}/` + imageUrl.CompressedUrl : imageUrl.image
        if(currentImage){
            const index = canvas.getObjects().indexOf(currentImage);
            addArtImage(url, currentImage.left, currentImage.top, canvas, id, activeSheet).then((newImage) => {
                canvas.remove(currentImage);
                canvas.moveTo(newImage, index);
                canvas.renderAll();
                dispatch(setLoading(false));
            })
        }else {
            addArtImage(url, 100, 100, canvas, id, activeSheet).then((newImage) => {
                canvas.renderAll();
                setImageSrc(newImage.getSrc())
                dispatch(setLoading(false));
            })
        }
    }

    return (
        <div className="image-properties-wrapper mt-3">
            <ModalDialog
                OpenModal={openReplaceModal}
                CloseModal={CloseReplaceModal}
                title="Replace Image"
                size="sm"
                ModalContent={<ReplaceModelContent setOpenReplaceModal={setOpenReplaceModal}/>}
                defaultScroll={true}
            />
            <div className='images-header'>
                <span className="heading-text">Edit Image</span>
                <span onClick={closeImagesPanel} className='cross-icon'><CloseIcon/></span>
            </div>

            <ImageViewer ToggleReplaceModal={ToggleReplaceModal} newInputHandler={newInputHandler} imageSrc={imageSrc} setImageSrc={setImageSrc}/>

            <ControlsWrapper>
                {controlItems.map((item, index) => (
                    <ControlItem key={index} onClick={item.onClick}>
                        {item.Icon}
                        <ControlTitle>{item.title}</ControlTitle>
                    </ControlItem>
                ))}
            </ControlsWrapper>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={()=>{
                    dispatch(setBackgroundState(true))
                    setValue(2)
                    handleClose()
                }}>
                    <ListItemIcon>
                        <PermMediaIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Gallery</ListItemText>
                </MenuItem>
                <MenuItem onClick={uploadFile}>
                    <ListItemIcon>
                        <CloudUploadIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>My Photos</ListItemText>
                </MenuItem>
            </Menu>
            <input
                ref={inputRef}
                onChange={newInputHandler}
                onClick={(e) => (e.target.value = null)}
                multiple="multiple"
                className="d-none"
                type="file"
                name="file"
                accept="*"
            />

            <hr className="solid-divider"/>
            {
                activeObject && (activeObject.type === 'group' || activeObject.type === 'path') &&
                <ExpandableColorHolder
                    className={"lf-mt-25"}
                    colors={activeObject.svgColorArray}
                    heading={"Svg Color"}
                    onColorSelect={changeSVGColor}
                />
            }
            <hr className="solid-divider"/>
            <BlendAndOpacity>
                <BlendMode>
                    <span>Blending mode</span>
                    <FormControl sx={{mt: 2, minWidth: 140}} size="small">
                        <Select
                            labelId="demo-select-small-label"
                            id="demo-select-small"
                            value={blendFilter}
                            displayEmpty
                            onChange={handleChangeBlend}
                        >
                            {blendModes.map((blendMode, index) => (
                                <MenuItem key={index} value={blendMode.mode}>
                                    {blendMode.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </BlendMode>
                <OpacityMode>
                    <span>Opacity</span>
                    <StyledSlider
                        sx={{mt: 2}}
                        aria-label="Always visible"
                        value={opacity}
                        getAriaValueText={valuetext}
                        marks={marks}
                        onChange={handleOpacityChange}
                    />
                </OpacityMode>
            </BlendAndOpacity>
            <div style={{width:'98%'}}>
                <span>Background opacity</span>
                <StyledSlider
                    sx={{mt: 2}}
                    aria-label="Always visible"
                    value={bgOpacity}
                    getAriaValueText={valuetext}
                    marks={marks}
                    onChange={handleBackgroundOpacity}
                />
            </div>
            <hr className="solid-divider"/>
            <SpecialEffectsWrapper>
                <h3>Image effects</h3>
                <>
                    <div className="effect-acordion" onClick={(e) => toggleAccordion(e, 'edgeEffects')}>
                        <div className="d-flex-center">
                            <div className='accordion-icon'><EffectIcon/></div>
                            <span className="name-heading">Edge Effects</span>
                        </div>
                        <div className="d-flex-center">
                            <ExpandMoreIcon/>
                        </div>
                    </div>
                    {edgeEffects && <div className="expandable-accordion">
                        <Box>
                            <List>
                                {shapeArray.map((item, index) => (
                                    <ListItem disablePadding key={index} selected={selectedPath === item.name} button
                                              onClick={() => applyClipPath(item)}>
                                        <ListItemButton>
                                            <ListItemText
                                                sx={{paddingLeft: 0}}
                                                inset
                                                primary={
                                                    <span>{item.name}</span>
                                                }
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                                {selectedPath === 'Curved' ?
                                    <div className="curve-amount-slider">
                                        <span>Curve Amount</span>
                                        <StyledSlider
                                            sx={{mt: 2, width: ' 50%'}}
                                            aria-label="Always visible"
                                            value={roundedCorner}
                                            getAriaValueText={valueRounded}
                                            marks={marks}
                                            onChange={handleRoundedChange}
                                        />
                                    </div> : ''
                                }
                            </List>
                        </Box>
                    </div>}
                </>
                <>
                    <div className="effect-acordion" onClick={(e) => toggleAccordion(e, 'filters')}>
                        <div className="d-flex-center">
                            <div className='accordion-icon'><EffectIcon/></div>
                            <span className="name-heading">Filter</span>
                        </div>
                        <div className="d-flex-center">
                            <ExpandMoreIcon/>
                        </div>
                    </div>
                    {imgFilter && <div className="expandable-accordion">
                        <Box>
                            <List>
                                {filters.map((filter, index) => (
                                    <StyledListItem key={index} button>
                                        <ListItemText primary={filter.name}/>
                                        <StyledSwitch
                                            checked={filter.enabled}
                                            onChange={() => toggleFilter(index)}
                                        />
                                    </StyledListItem>
                                ))}
                            </List>
                        </Box>
                    </div>}
                </>
                <>
                    <div className="effect-acordion" onClick={(e) => toggleAccordion(e, 'adjustments')}>
                        <div className="d-flex-center">
                            <div className='accordion-icon'><EffectIcon/></div>
                            <span className="name-heading">Adjustments</span>
                        </div>
                        <div className="d-flex-center">
                            <ExpandMoreIcon/>
                        </div>
                    </div>
                    {imgAdjustments && <div className="expandable-accordion">
                        <Box>
                            <Grid sx={{marginBottom: '10px'}} container spacing={2} alignItems="center">
                                <Grid xs={4} item>
                                    <span>Brightness</span>
                                </Grid>
                                <Grid item xs>
                                    <StyledSlider
                                        value={brightness}
                                        onChange={handleBrightnessChange}
                                        min={-100}
                                        max={100}
                                        aria-labelledby="input-slider"
                                    />
                                </Grid>
                                <Grid item>
                                    <Input
                                        value={brightness}
                                        size="small"
                                        onChange={(e) => handleBrightnessChange(e, +e.target.value)}
                                        inputProps={{
                                            min: -100,
                                            max: 100,
                                            type: 'number',
                                            'aria-labelledby': 'input-slider',
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid sx={{marginBottom: '10px'}} container spacing={2} alignItems="center">
                                <Grid xs={4} item>
                                    <span>Contrast</span>
                                </Grid>
                                <Grid item xs>
                                    <StyledSlider
                                        value={contrast}
                                        onChange={handleContrastChange}
                                        min={-100}
                                        max={100}
                                        aria-labelledby="input-slider"
                                    />
                                </Grid>
                                <Grid item>
                                    <Input
                                        value={contrast}
                                        size="small"
                                        onChange={(e) => handleContrastChange(e, +e.target.value)}
                                        inputProps={{
                                            min: -100,
                                            max: 100,
                                            type: 'number',
                                            'aria-labelledby': 'input-slider',
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid sx={{marginBottom: '10px'}} container spacing={2} alignItems="center">
                                <Grid xs={4} item>
                                    <span>Vibrance</span>
                                </Grid>
                                <Grid item xs>
                                    <StyledSlider
                                        value={vibrance}
                                        onChange={handleVibranceChange}
                                        min={-100}
                                        max={100}
                                        aria-labelledby="input-slider"
                                    />
                                </Grid>
                                <Grid item>
                                    <Input
                                        value={vibrance}
                                        size="small"
                                        onChange={(e) => handleVibranceChange(e, +e.target.value)}
                                        inputProps={{
                                            min: -100,
                                            max: 100,
                                            type: 'number',
                                            'aria-labelledby': 'input-slider',
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid sx={{marginBottom: '10px'}} container spacing={2} alignItems="center">
                                <Grid xs={4} item>
                                    <span>Saturation</span>
                                </Grid>
                                <Grid item xs>
                                    <StyledSlider
                                        value={saturation}
                                        onChange={handleSaturationChange}
                                        min={-100}
                                        max={100}
                                        aria-labelledby="input-slider"
                                    />
                                </Grid>
                                <Grid item>
                                    <Input
                                        value={saturation}
                                        size="small"
                                        onChange={(e) => handleSaturationChange(e, +e.target.value)}
                                        inputProps={{
                                            min: -100,
                                            max: 100,
                                            type: 'number',
                                            'aria-labelledby': 'input-slider',
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid sx={{marginBottom: '10px'}} container spacing={2} alignItems="center">
                                <Grid xs={4} item>
                                    <span>Noise</span>
                                </Grid>
                                <Grid item xs>
                                    <StyledSlider
                                        value={noise}
                                        onChange={handleNoiseChange}
                                        min={-100}
                                        max={100}
                                        aria-labelledby="input-slider"
                                    />
                                </Grid>
                                <Grid item>
                                    <Input
                                        value={noise}
                                        size="small"
                                        onChange={(e) => handleNoiseChange(e, +e.target.value)}
                                        inputProps={{
                                            min: -100,
                                            max: 100,
                                            type: 'number',
                                            'aria-labelledby': 'input-slider',
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </div>}
                </>
                <>
                    <div className="effect-acordion" onClick={(e) => toggleAccordion(e, 'blur')}>
                        <div className="d-flex-center">
                            <div className='accordion-icon'><EffectIcon/></div>
                            <span className="name-heading">Blur</span>
                        </div>
                        <div className="d-flex-center">
                            <ExpandMoreIcon/>
                        </div>
                    </div>
                    {imgBlur && <div className="expandable-accordion">
                        <Box>
                            <Grid sx={{marginBottom: '10px'}} container spacing={2} alignItems="center">
                                <Grid xs={4} item>
                                    <span>Blur</span>
                                </Grid>
                                <Grid item xs>
                                    <StyledSlider
                                        value={blur}
                                        onChange={handleBlurChange}
                                        min={0}
                                        max={100}
                                        aria-labelledby="input-slider"
                                    />
                                </Grid>
                                <Grid item>
                                    <Input
                                        value={blur}
                                        size="small"
                                        onChange={(e) => handleBlurChange(e, +e.target.value)}
                                        inputProps={{
                                            min: 0,
                                            max: 100,
                                            type: 'number',
                                            'aria-labelledby': 'input-slider',
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </div>}
                </>
            </SpecialEffectsWrapper>
            {openCropModal && createPortal(<div id="open-crop-modal-1122">
                    <CropModal
                        isModalOpen={openCropModal}
                        setIsModalOpen={setOpenCropModal}
                        okAction={cropEnd}
                        imageToCrop={canvas?.getActiveObject()?.originalSrc || canvas?.getActiveObject()?.getSrc()}
                        oldCrop={canvas?.getActiveObject()?.crop}
                    />
                </div>,
                document.body)
            }
        </div>
    );
}

export default ImageProperties;
